import React from 'react';
import { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { Typography } from "@material-ui/core";
import ReactLoading from 'react-loading';
import { usePedidos } from '../../../../../contexts/Pedidos';
import { useHistory } from 'react-router-dom';
import { Derivacao, ArrayDerivacoes, ArrayProdutos, Produto } from '../../../interfaces';
import { FieldDropdownVer2 } from '../../../../../themes/components/FieldDropdown';
import { TabelaAddItemNovoPedido } from '../../TabelaAddItemNovoPedido';
import { Button } from '../../../../../themes/components/Button';
import { useModals } from '../../../../../contexts/Modals';
import { saveInSessionStorage, getFromSessionStorage } from '../../../../../contexts/LocalStorage';
import { validarQuantidadeCorte, validarToleranciaPreco } from '../../../../../util/rulesSale';
import { useDeepCompareEffect, useSessionStorage } from 'react-use';

interface propsModalAdicionarItemNovoPedido {
    showModal: boolean;
    setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
    salvarAndamentoPedido: () => void;
}

export function ModalAdicionarItemNovoPedido(props: propsModalAdicionarItemNovoPedido) {
    let history = useHistory();
    const { itensDigitacaoPedido, setItensDigitacaoPedido, buscarDerivacoes, filtrarProdutos, idPrePedido } = usePedidos();
    const { mostrarInfoOK } = useModals();
    const [selected, setSelected] = useState<string[]>([]);
    const [valorTotalAdicionados, setValorTotalAdicionados] = useState<number>(0);
    const [valorDolarTotalAdicionados, setValorDolarTotalAdicionados] = useState<number>(0);
    const [quantidadeTotalAdicionados, setQuantidadeTotalAdicionados] = useState<number>(0);
    const [listaProdutos, setListaProdutos] = useState<ArrayProdutos>();
    const [listaDerivacoes, setListaDerivacoes] = useState<ArrayDerivacoes>([]);
    const [editableTableItens, setEditableTableItens] = useState<any>();
    const [loadingItens, setLoadingItens] = useState<boolean>(false);
    const [loadingProdutos, setLoadingProdutos] = useState<boolean>(false);
    const [fieldProduto, setFieldProduto] = useState<string>("");
    const [nomeproduto, setnomeproduto] = useState<string>("");
    const [idItemErro, setIdItemErro] = useState<string>("");
    const [valueX, setValueX] = useState(0);

    useEffect(() => {
        setEditableTableItens(listaDerivacoes);
    }, [listaDerivacoes]);

    function checkItemAdicionado(item: Derivacao) {
        for (let index = 0; index < itensDigitacaoPedido.length; index++) {
            const itemNoCarrinho = itensDigitacaoPedido[index];
            if (itemNoCarrinho.codclc === item.codclc &&
                itemNoCarrinho.codder === item.codder &&
                itemNoCarrinho.codpro === item.codpro &&
                itemNoCarrinho.codctn === item.codctn &&
                itemNoCarrinho.pretab === item.pretab) {
                return true;
            }
        }
        return false;
    }

    function isSelected(cod:string){
        for (let index = 0; index < selected.length; index++) {
            const element = selected[index];
            if(element === cod){
                return true;
            }
        }
        return false;
    }

    //Função para verificar se o módulo da quantidade adicionada pela quantidade de corte é igual a 0
    function validarQtdCorte(qtdTotal: string, qtdCorte: number) {
        if (qtdCorte <= 1) {
            return true;
        }
        let res = parseFloat(qtdTotal) % qtdCorte
        if (res === 0) {
            return true
        } else {
            return false
        }
    }

    function validarQuantidadeAdicionada(qtdTotal: number, saldo: number) {
        if (Math.fround(qtdTotal) > Math.fround(saldo)) {
            return false;
        } else {
            return true;
        }
    }

    function validarItensSelecionados() {
        let itensTemp = [...itensDigitacaoPedido];
        if (selected.length > 0) {
            //Varrendo cada item marcado na tabela de itens
            for (let cont = 0; cont < selected.length; cont++) {
                const element: string = selected[cont];
                //Varrendo cada item da tabela editável para encontrar os itens selecionados nela
                for (let index = 0; index < editableTableItens.length; index++) {
                    const elementEditado = editableTableItens[index];
                    if (elementEditado.codder + elementEditado.codpro + elementEditado.codctn === element) {
                        //validando se o item tem alguma quantidade definida
                        if (elementEditado.quantidade > 0) {
                            //validando que o item ainda não foi inserido no pedido
                            if (validarQtdCorte(elementEditado.quantidade, elementEditado.quantidadecorte !== undefined && typeof elementEditado.quantidadecorte !== 'string' ? elementEditado.quantidadecorte : 1)) {
                                if (validarQuantidadeAdicionada(elementEditado.quantidade, parseFloat(elementEditado.salime.replace(",", ".")) + parseFloat(elementEditado.salpro.replace(",", ".")))) {
                                    if (checkItemAdicionado(elementEditado)) {
                                        //item já adicionado ao pedido
                                        setIdItemErro(elementEditado.codder + elementEditado.codpro + elementEditado.codctn);
                                        mostrarInfoOK("Produto " + elementEditado.codpro + " Derivação " + elementEditado.codder + " - " + elementEditado.desder + " já foi adicionado ao pedido!");
                                        return false;
                                    } else {
                                        if (elementEditado.precoVenda === undefined || validarToleranciaPreco(parseFloat(elementEditado.precoVenda), parseFloat(elementEditado.pretab), parseFloat(elementEditado.tolmen), parseFloat(elementEditado.tolmai))) {
                                            if (elementEditado.quantidadecorte === undefined || elementEditado.quantidadecorte === 'vazio' || validarQuantidadeCorte(parseInt(elementEditado.qtdpcs), parseInt(elementEditado.quantidadecorte))) {
                                                //Item realmente editado encontrado, agora ele será adicionado ao pedido
                                                //O nome do produto não existe no objeto derivações, então é pego do campo de busca do produto pra adicionar no item do pedido
                                                elementEditado.nomeproduto = nomeproduto;
                                                //console.log(elementEditado);
                                                itensTemp.push(elementEditado);
                                            } else {
                                                setIdItemErro(elementEditado.codder + elementEditado.codpro + elementEditado.codctn);
                                                mostrarInfoOK("Produto " + elementEditado.codpro + " Derivação " + elementEditado.codder + " - " + elementEditado.desder + " Está quantidade de corte acima do tamanho da peça: " + elementEditado.qtdpcs);
                                                return false;
                                            }
                                        } else {
                                            setIdItemErro(elementEditado.codder + elementEditado.codpro + elementEditado.codctn);
                                            mostrarInfoOK("Produto " + elementEditado.codpro + " Derivação " + elementEditado.codder + " - " + elementEditado.desder + " Está com preço fora da tolerância!");
                                            return false;
                                        }
                                    }
                                } else {
                                    setIdItemErro(elementEditado.codder + elementEditado.codpro + elementEditado.codctn);
                                    mostrarInfoOK("Produto " + elementEditado.codpro + " Derivação " + elementEditado.codder + " - " + elementEditado.desder + " não possue saldo suficiente!");
                                    return false;
                                }
                            } else {
                                setIdItemErro(elementEditado.codder + elementEditado.codpro + elementEditado.codctn);
                                mostrarInfoOK("Produto " + elementEditado.codpro + " Derivação " + elementEditado.codder + " - " + elementEditado.desder + " possue um valor de corte inválido!", "O campo quantidade precisa ser um multiplo do campo corte!");
                                return false;
                            }
                        } else {
                            mostrarInfoOK("Há produtos selecionados sem quantidade.", "Desmarque ou adicione uma quantidade!");
                            setIdItemErro(elementEditado.codder + elementEditado.codpro + elementEditado.codctn);
                            return false;
                        }
                    }
                }
            }
            setItensDigitacaoPedido(itensTemp);
            return true;
        } else {
            mostrarInfoOK("Nenhum produto selecionado!");
            return false;
        }
    }

    function addItensAoPedido() {
        let val = validarItensSelecionados();
        if (val === true) {
            handleCloseModal();
        } else {
            setValueX(valueX + 1);
        }
    }

    function handleChangeProduto(event: any, option: string, reason: any) {
        async function getProduto() {
            await filtrarProdutos(event.target.value, history)
                .then((res) => {
                    setListaProdutos(res);
                    setLoadingProdutos(false);
                })
                .catch((err) => {
                    if (err !== "Cancel") {
                        setListaProdutos([]);
                        console.log(err);
                        setLoadingProdutos(false);
                    }
                })

        }

        if (reason === "input" && event !== null && event.target.value.trim() !== "") {
            if (fieldProduto !== "") {
                setFieldProduto("");
            }
            setLoadingProdutos(true);
            getProduto();
        }

        if (reason === "reset" && option.trim() !== "") {
            let cod = new RegExp("[0-9]*", '').exec(option);
            let nomeproduto = option.replace(new RegExp("(.*- )", ''), "");
            if (cod !== null) setFieldProduto(cod[0]);
            if (nomeproduto !== null) setnomeproduto(nomeproduto);
            //console.log("entrou no reset")
        }
        //console.log(nomeproduto)
    }

    useEffect(() => {
        async function getDerivacoes(produto: string) {
            await buscarDerivacoes(produto, history)
                .then((res) => {
                    //console.log(res);
                    setListaDerivacoes(res);
                    setLoadingItens(false);
                })
                .catch((err) => {
                    setListaDerivacoes([]);
                    setLoadingItens(false);
                })

        }
        if (fieldProduto !== "") {
            clearModalAddItens();
            setLoadingItens(true);
            getDerivacoes(fieldProduto);
        } else {
            setListaDerivacoes([]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fieldProduto])

    function clearModalAddItens() {
        setIdItemErro("");
        setSelected([]);
        setListaProdutos([]);
        setListaDerivacoes([]);
        setEditableTableItens([]);
        setValorTotalAdicionados(0);
        saveInSessionStorage("qtdaplicar", "");
        saveInSessionStorage("valoraplicar", "");
    }


    useEffect(() => {
        let tempValorTotal: number = 0
        let tempQtd: number = 0
        selected.forEach((element: string) => {
            //Varrendo cada item da tabela editável para encontrar os itens selecionados nela
            for (let index = 0; index < editableTableItens.length; index++) {
                const elementEditado = editableTableItens[index];
                if (elementEditado.codder + elementEditado.codpro + elementEditado.codctn === element && isSelected(elementEditado.codder + elementEditado.codpro + elementEditado.codctn)) {
                    //validando se o item tem alguma quantidade definida
                    if (elementEditado.quantidade > 0 && elementEditado.valortotal !== undefined) {
                        //validando que o item ainda não foi inserido no pedido
                        tempValorTotal += elementEditado.valortotal;
                        tempQtd += parseFloat(elementEditado.quantidade);
                    }
                }
            };
        });
        setValorTotalAdicionados(tempValorTotal);
        setQuantidadeTotalAdicionados(tempQtd);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [itensDigitacaoPedido, editableTableItens, valueX, selected]);



    function handleCloseModal() {
        props.setShowModal(false);
        clearModalAddItens();
        setFieldProduto("");
        setnomeproduto("");
    }

    return (
        <Modal
            show={props.showModal}
            onHide={() => handleCloseModal()}
            dialogClassName="modal-120w"
            animation={true}
            centered={true}
            size={"xl"}
            style={{ overflow: 'hidden' }}
        >
            <Modal.Header closeButton className="modal-header-adicionar-itens-pedido">
                <Modal.Title className="detalhe-adicionar-itens-titulo-modal">
                    <Typography className="detalhe-adicionar-itens-texto-titulo">Adicionar Itens {fieldProduto !== "" ? " - " + fieldProduto + " " + nomeproduto : ""}</Typography>
                </Modal.Title>
            </Modal.Header>
            {props.showModal === true &&
                <Modal.Body
                    style={{ overflow: 'hidden' }}>
                    <div className="modal-container-additens-area">
                        <label className={"modal-additens-title"} htmlFor="modal-additens-title"><b>Pesquisar Produto:</b></label>
                        <div className="modal-search-product-area">
                            <div className="modal-additens-searchfield">
                                <FieldDropdownVer2
                                    id="additens-combobox-searchproduto"
                                    options={listaProdutos || []}
                                    loading={loadingProdutos}
                                    select={(option: Produto, value: Produto) => option.codclc === value.codclc}
                                    label={(option: Produto) => option.codclc !== undefined ? option.codclc + " - " + option.nompro : ""}
                                    onChange={(event, option, reason) => handleChangeProduto(event, option, reason)}
                                    noOptionsText={"Digite um código ou nome válido"}
                                />
                            </div>
                        </div>
                        <>
                            {loadingItens ?
                                <ReactLoading type={"bars"} color={"#0252a8"} height={30} width={50} className="detalhe-adicionar-itens-titulo-loading" />
                                :
                                <>
                                    <div className="modal-derivation-table-area">
                                        <TabelaAddItemNovoPedido allowSelectitem={true} setIdItemErro={setIdItemErro} itensTabela={editableTableItens} setItensTabela={setEditableTableItens} setSelected={setSelected} selected={selected} valueX={valueX} setValueX={setValueX} idItemErro={idItemErro} />
                                    </div>

                                    <div className="modal-additens-footer-itens-area">
                                        <div className="modal-additens-footer-info-area">
                                            <Typography className="modal-additens-footer-info-text"><b>Quantidade Total:</b> {quantidadeTotalAdicionados.toLocaleString('pt-br', { style: 'decimal', maximumFractionDigits: 2 })}</Typography>
                                            <Typography className="modal-additens-footer-info-text"><b>Valor Total:</b> {valorTotalAdicionados.toLocaleString('pt-br', { currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 })}{getFromSessionStorage("pedDol") === "XPTO" ? ` (Total em Dólar: ${valorDolarTotalAdicionados.toLocaleString('en-US', {style: 'currency', currency: 'USD'})})` : ""}</Typography>
                                        </div>
                                        <div className="modal-additens-footer-addbotoes-area">
                                            <Button onClick={() => handleCloseModal()} classBtn={"btn-footer-novo-pedido color-red"}>Cancelar</Button>
                                            <Button onClick={() => addItensAoPedido()} classBtn={"btn-footer-novo-pedido color-default"}>Adicionar</Button>
                                        </div>
                                    </div>
                                </>
                            }
                        </>
                    </div>
                </Modal.Body>
            }
        </Modal>
    );
}